import { Box } from "@mui/material";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { EventProps } from "react-big-calendar";
import Flex from "../../../../../../components/Flex";
import Text from "../../../../../../components/Text";
import { AppointmentSchedulingType } from "../../../../../../dummy-data/appointment-list-data-scheduling";
import { formatTime } from "../../../../../../utils/date-time-utility";
import { getAge } from "../../../../../../utils/utils";
import {
  APPOINTMENT_STATUS_RECORD,
  COLOR_MAPPER,
} from "../../../scheduling/appointment/AppointmentScheduling";
import { eventWrapper } from "../../../scheduling/availability/scheduling-utils";

const MODE_ICON_MAPPER: Record<string, React.ReactNode> = {
  IN_PERSON: <PersonOutlinedIcon sx={{ fontSize: "14px" }} color="primary" />,
  VIRTUAL: <VideocamOutlinedIcon sx={{ fontSize: "14px" }} color="primary" />,
};

const DashboardEventWrapper = ({ props }: { props: EventProps }) => {
  const event = props.event as any;
  const startMs = new Date(event?.startTime).getTime();
  const endMs = new Date(event?.endTime).getTime();
  const durationMin = (endMs - startMs) / 60000;

  // Long events (> 15 min): use the shared full-layout eventWrapper
  if (durationMin > 15) {
    return eventWrapper(props, "day", false);
  }

  // Short events (≤ 15 min): single horizontal row
  const statusLabel =
    APPOINTMENT_STATUS_RECORD[
      event?.status as AppointmentSchedulingType["status"]
    ];
  const activeStatusColor = COLOR_MAPPER[statusLabel];
  const age = getAge(event?.patientDob);
  const gender = event?.patientGender?.toUpperCase()?.slice(0, 1);

  return (
    <Flex
      height="100%"
      width="100%"
      borderRadius="8px"
      bgcolor={activeStatusColor?.bgColor || "#F3F4F6"}
      alignItems="center"
    >
      <Box
        minWidth="4px"
        height="100%"
        borderRadius="4px 0 0 4px"
        bgcolor={activeStatusColor?.color}
      />
      <Flex
        ml={0.5}
        alignItems="center"
        gap={1}
        overflow="hidden"
        flexWrap="nowrap"
        width="100%"
        pr={1}
      >
        <Text
          sx={{
            fontWeight: 500,
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {`${props.title} (${age}${gender ? `, ${gender}` : ""})`}
        </Text>
        {MODE_ICON_MAPPER[event?.mode]}
        <Text
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
          color={activeStatusColor?.color}
        >
          {statusLabel}
        </Text>
        <Text
          sx={{
            fontSize: "12px",
            whiteSpace: "nowrap",
            color: "#6B7280",
            marginLeft: "auto",
          }}
        >
          {`${formatTime(event?.startTime)} - ${formatTime(event?.endTime)}`}
        </Text>
      </Flex>
    </Flex>
  );
};

export default DashboardEventWrapper;
